import { render, staticRenderFns } from "./ProductsReportFilter.vue?vue&type=template&id=59a272d7&scoped=true"
import script from "./ProductsReportFilter.vue?vue&type=script&lang=js"
export * from "./ProductsReportFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductsReportFilter.vue?vue&type=style&index=0&id=59a272d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a272d7",
  null
  
)

export default component.exports